import { useId } from "react";
import { Col, Form } from "react-bootstrap";
export default function FormField({
  name,
  label,
  value,
  onChange,
  type = "text",
  options,
  md = 4,
  required = false,
  error,
  disabled,
  maxLength,
  min,
  max,
  help,
}) {
  const fieldId = useId();
  const controlProps = {
    value: value ?? "",
    disabled,
    isInvalid: Boolean(error),
    onChange: (event) =>
      onChange(
        name,
        type === "checkbox" ? event.target.checked : event.target.value,
      ),
  };
  return (
    <Col xs={12} md={md}>
      <Form.Group controlId={`field-${name}-${fieldId}`}>
        {type !== "checkbox" && (
          <Form.Label>
            {label}
            {required ? " *" : ""}
          </Form.Label>
        )}
        {type === "checkbox" ? (
          <Form.Check
            id={`check-${name}-${fieldId}`}
            label={label}
            checked={value === true || value === 1 || value === "1"}
            disabled={disabled}
            onChange={controlProps.onChange}
          />
        ) : options ? (
          <Form.Select {...controlProps}>
            <option value="">Selecciona…</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
        ) : (
          <Form.Control
            {...controlProps}
            type={type === "textarea" ? undefined : type}
            as={type === "textarea" ? "textarea" : undefined}
            rows={type === "textarea" ? 3 : undefined}
            maxLength={maxLength}
            min={min}
            max={max}
            step={type === "number" ? "any" : undefined}
          />
        )}
        {error && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        )}
        {help && <Form.Text>{help}</Form.Text>}
      </Form.Group>
    </Col>
  );
}
